var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "order-tmp-caption",
          staticStyle: {
            "font-size": "15px",
            color: "#1a1a1a",
            "font-weight": "600",
            "text-align": "center",
            padding: "15px 0"
          }
        },
        [_c("span", [_vm._v(_vm._s(_vm.devcMaintVoucher.title))])]
      ),
      _vm._v(" "),
      _vm._l(_vm.devcMaintVoucher.comnItemList, function(comnItem) {
        return _c(
          "table",
          {
            staticClass: "simple-tbl",
            staticStyle: {
              width: "100%",
              "table-layout": "fixed",
              "border-collapse": "collapse",
              "border-spacing": "2px",
              "border-color": "gray",
              color: "#666",
              "font-size": "12px"
            }
          },
          [
            _c("tbody", { staticClass: "body" }, [
              comnItem.dtType != 8 && comnItem.dtType != 3
                ? _c("tr", { staticClass: "row" }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          border: "1px solid #1a1a1a",
                          "vertical-align": "middle",
                          padding: "10px 4px"
                        },
                        attrs: { colspan: "4" }
                      },
                      [
                        _c("div", {}, [
                          _vm._v(
                            _vm._s(comnItem.label) +
                              "：" +
                              _vm._s(comnItem.value)
                          )
                        ])
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              comnItem.dtType == 8
                ? _c("tr", { staticClass: "row" }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          border: "1px solid #1a1a1a",
                          "vertical-align": "middle",
                          padding: "10px 4px"
                        },
                        attrs: { colspan: "4" }
                      },
                      [
                        _c("div", {}, [
                          _vm._v(
                            _vm._s(comnItem.label) +
                              "：" +
                              _vm._s(comnItem.value ? "是" : "否")
                          )
                        ])
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              comnItem.dtType == 3
                ? _c("tr", { staticClass: "row" }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          border: "1px solid #1a1a1a",
                          "vertical-align": "middle",
                          padding: "10px 4px"
                        },
                        attrs: { colspan: "4" }
                      },
                      [
                        _c("div", {}, [
                          _vm._v(
                            _vm._s(comnItem.label) +
                              "：" +
                              _vm._s(
                                new Date(comnItem.value).format(
                                  "yyyy年MM月dd日"
                                )
                              )
                          )
                        ])
                      ]
                    )
                  ])
                : _vm._e()
            ])
          ]
        )
      }),
      _vm._v(" "),
      _vm.groupFlag
        ? [
            _c(
              "table",
              {
                staticClass: "simple-tbl",
                staticStyle: {
                  width: "100%",
                  "table-layout": "fixed",
                  "border-collapse": "collapse",
                  "border-spacing": "2px",
                  "border-color": "gray",
                  color: "#666",
                  "font-size": "12px"
                }
              },
              [
                _c("thead", { staticClass: "head" }, [
                  _c("tr", { staticClass: "row" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _vm._m(1),
                    _vm._v(" "),
                    _vm._m(2),
                    _vm._v(" "),
                    _vm._m(3),
                    _vm._v(" "),
                    _vm.devcMaintVoucher.examAndScoreFlag
                      ? _c(
                          "th",
                          {
                            staticStyle: {
                              border: "1px solid #1a1a1a",
                              "vertical-align": "middle",
                              padding: "10px 4px",
                              color: "#1a1a1a",
                              "font-weight": "600"
                            }
                          },
                          [_c("div", [_vm._v("评分标准")])]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.devcMaintVoucher.examAndScoreFlag
                      ? _c(
                          "th",
                          {
                            staticStyle: {
                              border: "1px solid #1a1a1a",
                              "vertical-align": "middle",
                              padding: "10px 4px",
                              color: "#1a1a1a",
                              "font-weight": "60",
                              width: "60px"
                            }
                          },
                          [_c("div", [_vm._v("满分")])]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.devcMaintVoucher.examAndScoreFlag
                      ? _c(
                          "th",
                          {
                            staticStyle: {
                              border: "1px solid #1a1a1a",
                              "vertical-align": "middle",
                              padding: "10px 4px",
                              color: "#1a1a1a",
                              "font-weight": "60",
                              width: "60px"
                            }
                          },
                          [_c("div", [_vm._v("得分")])]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._m(4),
                    _vm._v(" "),
                    _vm._m(5),
                    _vm._v(" "),
                    _vm._m(6)
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  { staticClass: "body" },
                  [
                    _vm._l(_vm.devcMaintVoucher.checkItemList, function(
                      checkItem,
                      index
                    ) {
                      return _c("tr", { staticClass: "row" }, [
                        _c(
                          "td",
                          {
                            staticStyle: {
                              border: "1px solid #1a1a1a",
                              "vertical-align": "middle",
                              padding: "10px 4px"
                            }
                          },
                          [_c("div", [_vm._v(_vm._s(index + 1))])]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              border: "1px solid #1a1a1a",
                              "vertical-align": "middle",
                              padding: "10px 4px"
                            }
                          },
                          [_c("div", [_vm._v(_vm._s(checkItem.group))])]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              border: "1px solid #1a1a1a",
                              "vertical-align": "middle",
                              padding: "10px 4px"
                            }
                          },
                          [_c("div", [_vm._v(_vm._s(checkItem.content))])]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              border: "1px solid #1a1a1a",
                              "vertical-align": "middle",
                              padding: "10px 4px"
                            }
                          },
                          [_c("div", [_vm._v(_vm._s(checkItem.demand))])]
                        ),
                        _vm._v(" "),
                        _vm.devcMaintVoucher.examAndScoreFlag
                          ? _c(
                              "td",
                              {
                                staticStyle: {
                                  border: "1px solid #1a1a1a",
                                  "vertical-align": "middle",
                                  padding: "10px 4px"
                                }
                              },
                              [
                                _c("div", [
                                  _vm._v(_vm._s(checkItem.scoreStd || ""))
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.devcMaintVoucher.examAndScoreFlag
                          ? _c(
                              "td",
                              {
                                staticStyle: {
                                  border: "1px solid #1a1a1a",
                                  "vertical-align": "middle",
                                  padding: "10px 4px"
                                }
                              },
                              [
                                _c("div", [
                                  _vm._v(_vm._s(checkItem.fullScore || ""))
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.devcMaintVoucher.examAndScoreFlag
                          ? _c(
                              "td",
                              {
                                staticStyle: {
                                  border: "1px solid #1a1a1a",
                                  "vertical-align": "middle",
                                  padding: "10px 4px"
                                }
                              },
                              [
                                _c("div", [
                                  _vm._v(_vm._s(checkItem.evalScore || ""))
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              border: "1px solid #1a1a1a",
                              "vertical-align": "middle",
                              padding: "10px 4px"
                            }
                          },
                          [
                            _c("div", [
                              _vm._v(
                                _vm._s(checkItem.snapshotRequired ? "是" : "否")
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              border: "1px solid #1a1a1a",
                              "vertical-align": "middle",
                              padding: "10px 4px"
                            }
                          },
                          [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  checkItem.markChar == "✓"
                                    ? "√"
                                    : checkItem.markChar
                                )
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              border: "1px solid #1a1a1a",
                              "vertical-align": "middle",
                              padding: "10px 4px"
                            }
                          },
                          [_c("div", [_vm._v(_vm._s(checkItem.remark))])]
                        )
                      ])
                    }),
                    _vm._v(" "),
                    _c("tr", { staticClass: "row" }, [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            border: "1px solid #1a1a1a",
                            "vertical-align": "middle",
                            padding: "10px 4px"
                          },
                          attrs: {
                            colspan: _vm.devcMaintVoucher.examAndScoreFlag
                              ? 10
                              : 7
                          }
                        },
                        [
                          _c("div", {}, [
                            _vm._v(
                              "说明：" +
                                _vm._s(_vm.devcMaintVoucher.checkItemStateText)
                            )
                          ])
                        ]
                      )
                    ])
                  ],
                  2
                )
              ]
            )
          ]
        : _vm.remarkFlag
        ? [
            _c(
              "table",
              {
                staticClass: "simple-tbl",
                staticStyle: {
                  width: "100%",
                  "table-layout": "fixed",
                  "border-collapse": "collapse",
                  "border-spacing": "2px",
                  "border-color": "gray",
                  color: "#666",
                  "font-size": "12px"
                }
              },
              [
                _c("thead", { staticClass: "head" }, [
                  _c("tr", { staticClass: "row" }, [
                    _vm._m(7),
                    _vm._v(" "),
                    _vm._m(8),
                    _vm._v(" "),
                    _vm._m(9),
                    _vm._v(" "),
                    _vm.devcMaintVoucher.examAndScoreFlag
                      ? _c(
                          "th",
                          {
                            staticStyle: {
                              border: "1px solid #1a1a1a",
                              "vertical-align": "middle",
                              padding: "10px 4px",
                              color: "#1a1a1a",
                              "font-weight": "120"
                            }
                          },
                          [_c("div", [_vm._v("评分标准")])]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.devcMaintVoucher.examAndScoreFlag
                      ? _c(
                          "th",
                          {
                            staticStyle: {
                              border: "1px solid #1a1a1a",
                              "vertical-align": "middle",
                              padding: "10px 4px",
                              color: "#1a1a1a",
                              "font-weight": "60",
                              width: "60px"
                            }
                          },
                          [_c("div", [_vm._v("满分")])]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.devcMaintVoucher.examAndScoreFlag
                      ? _c(
                          "th",
                          {
                            staticStyle: {
                              border: "1px solid #1a1a1a",
                              "vertical-align": "middle",
                              padding: "10px 4px",
                              color: "#1a1a1a",
                              "font-weight": "60",
                              width: "60px"
                            }
                          },
                          [_c("div", [_vm._v("得分")])]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._m(10),
                    _vm._v(" "),
                    _vm._m(11),
                    _vm._v(" "),
                    _vm._m(12)
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  { staticClass: "body" },
                  [
                    _vm._l(_vm.devcMaintVoucher.checkItemList, function(
                      checkItem,
                      index
                    ) {
                      return _c("tr", { staticClass: "row" }, [
                        _c(
                          "td",
                          {
                            staticStyle: {
                              border: "1px solid #1a1a1a",
                              "vertical-align": "middle",
                              padding: "10px 4px"
                            }
                          },
                          [_c("div", [_vm._v(_vm._s(index + 1))])]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              border: "1px solid #1a1a1a",
                              "vertical-align": "middle",
                              padding: "10px 4px"
                            }
                          },
                          [_c("div", [_vm._v(_vm._s(checkItem.content))])]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              border: "1px solid #1a1a1a",
                              "vertical-align": "middle",
                              padding: "10px 4px"
                            }
                          },
                          [_c("div", [_vm._v(_vm._s(checkItem.demand))])]
                        ),
                        _vm._v(" "),
                        _vm.devcMaintVoucher.examAndScoreFlag
                          ? _c(
                              "td",
                              {
                                staticStyle: {
                                  border: "1px solid #1a1a1a",
                                  "vertical-align": "middle",
                                  padding: "10px 4px"
                                }
                              },
                              [
                                _c("div", [
                                  _vm._v(_vm._s(checkItem.scoreStd || ""))
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.devcMaintVoucher.examAndScoreFlag
                          ? _c(
                              "td",
                              {
                                staticStyle: {
                                  border: "1px solid #1a1a1a",
                                  "vertical-align": "middle",
                                  padding: "10px 4px"
                                }
                              },
                              [
                                _c("div", [
                                  _vm._v(_vm._s(checkItem.fullScore || ""))
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.devcMaintVoucher.examAndScoreFlag
                          ? _c(
                              "td",
                              {
                                staticStyle: {
                                  border: "1px solid #1a1a1a",
                                  "vertical-align": "middle",
                                  padding: "10px 4px"
                                }
                              },
                              [
                                _c("div", [
                                  _vm._v(_vm._s(checkItem.evalScore || ""))
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              border: "1px solid #1a1a1a",
                              "vertical-align": "middle",
                              padding: "10px 4px"
                            }
                          },
                          [
                            _c("div", [
                              _vm._v(
                                _vm._s(checkItem.snapshotRequired ? "是" : "否")
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              border: "1px solid #1a1a1a",
                              "vertical-align": "middle",
                              padding: "10px 4px"
                            }
                          },
                          [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  checkItem.markChar == "✓"
                                    ? "√"
                                    : checkItem.markChar
                                )
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              border: "1px solid #1a1a1a",
                              "vertical-align": "middle",
                              padding: "10px 4px"
                            }
                          },
                          [_c("div", [_vm._v(_vm._s(checkItem.remark))])]
                        )
                      ])
                    }),
                    _vm._v(" "),
                    _c("tr", { staticClass: "row" }, [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            border: "1px solid #1a1a1a",
                            "vertical-align": "middle",
                            padding: "10px 4px"
                          },
                          attrs: {
                            colspan: _vm.devcMaintVoucher.examAndScoreFlag
                              ? 9
                              : 7
                          }
                        },
                        [
                          _c("div", {}, [
                            _vm._v(
                              "说明：" +
                                _vm._s(_vm.devcMaintVoucher.checkItemStateText)
                            )
                          ])
                        ]
                      )
                    ])
                  ],
                  2
                )
              ]
            )
          ]
        : [
            _c(
              "table",
              {
                staticClass: "simple-tbl",
                staticStyle: {
                  width: "100%",
                  "table-layout": "fixed",
                  "border-collapse": "collapse",
                  "border-spacing": "2px",
                  "border-color": "gray",
                  color: "#666",
                  "font-size": "12px"
                }
              },
              [
                _c("thead", { staticClass: "head" }, [
                  _c("tr", { staticClass: "row" }, [
                    _vm._m(13),
                    _vm._v(" "),
                    _vm._m(14),
                    _vm._v(" "),
                    _vm._m(15),
                    _vm._v(" "),
                    _vm._m(16),
                    _vm._v(" "),
                    _vm.devcMaintVoucher.examAndScoreFlag
                      ? _c(
                          "th",
                          {
                            staticStyle: {
                              border: "1px solid #1a1a1a",
                              "vertical-align": "middle",
                              padding: "10px 4px",
                              color: "#1a1a1a",
                              "font-weight": "600"
                            }
                          },
                          [_c("div", [_vm._v("评分标准")])]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.devcMaintVoucher.examAndScoreFlag
                      ? _c(
                          "th",
                          {
                            staticStyle: {
                              border: "1px solid #1a1a1a",
                              "vertical-align": "middle",
                              padding: "10px 4px",
                              color: "#1a1a1a",
                              "font-weight": "60",
                              width: "60px"
                            }
                          },
                          [_c("div", [_vm._v("满分")])]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.devcMaintVoucher.examAndScoreFlag
                      ? _c(
                          "th",
                          {
                            staticStyle: {
                              border: "1px solid #1a1a1a",
                              "vertical-align": "middle",
                              padding: "10px 4px",
                              color: "#1a1a1a",
                              "font-weight": "60",
                              width: "60px"
                            }
                          },
                          [_c("div", [_vm._v("得分")])]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._m(17)
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  { staticClass: "body" },
                  [
                    _vm._l(_vm.devcMaintVoucher.checkItemList, function(
                      checkItem,
                      index
                    ) {
                      return _c("tr", { staticClass: "row" }, [
                        _c(
                          "td",
                          {
                            staticStyle: {
                              border: "1px solid #1a1a1a",
                              "vertical-align": "middle",
                              padding: "10px 4px"
                            }
                          },
                          [_c("div", [_vm._v(_vm._s(index + 1))])]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              border: "1px solid #1a1a1a",
                              "vertical-align": "middle",
                              padding: "10px 4px"
                            }
                          },
                          [_c("div", [_vm._v(_vm._s(checkItem.content))])]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              border: "1px solid #1a1a1a",
                              "vertical-align": "middle",
                              padding: "10px 4px"
                            }
                          },
                          [_c("div", [_vm._v(_vm._s(checkItem.demand))])]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              border: "1px solid #1a1a1a",
                              "vertical-align": "middle",
                              padding: "10px 4px"
                            }
                          },
                          [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  checkItem.markChar == "✓"
                                    ? "√"
                                    : checkItem.markChar
                                )
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm.devcMaintVoucher.examAndScoreFlag
                          ? _c(
                              "td",
                              {
                                staticStyle: {
                                  border: "1px solid #1a1a1a",
                                  "vertical-align": "middle",
                                  padding: "10px 4px"
                                }
                              },
                              [
                                _c("div", [
                                  _vm._v(_vm._s(checkItem.scoreStd || ""))
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.devcMaintVoucher.examAndScoreFlag
                          ? _c(
                              "td",
                              {
                                staticStyle: {
                                  border: "1px solid #1a1a1a",
                                  "vertical-align": "middle",
                                  padding: "10px 4px"
                                }
                              },
                              [
                                _c("div", [
                                  _vm._v(_vm._s(checkItem.fullScore || ""))
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.devcMaintVoucher.examAndScoreFlag
                          ? _c(
                              "td",
                              {
                                staticStyle: {
                                  border: "1px solid #1a1a1a",
                                  "vertical-align": "middle",
                                  padding: "10px 4px"
                                }
                              },
                              [
                                _c("div", [
                                  _vm._v(_vm._s(checkItem.evalScore || 0))
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              border: "1px solid #1a1a1a",
                              "vertical-align": "middle",
                              padding: "10px 4px"
                            }
                          },
                          [
                            _c("div", [
                              _vm._v(
                                _vm._s(checkItem.snapshotRequired ? "是" : "否")
                              )
                            ])
                          ]
                        )
                      ])
                    }),
                    _vm._v(" "),
                    _c("tr", { staticClass: "row" }, [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            border: "1px solid #1a1a1a",
                            "vertical-align": "middle",
                            padding: "10px 4px"
                          },
                          attrs: {
                            colspan: _vm.devcMaintVoucher.examAndScoreFlag
                              ? 8
                              : 5
                          }
                        },
                        [
                          _c("div", {}, [
                            _vm._v(
                              "说明：" +
                                _vm._s(_vm.devcMaintVoucher.checkItemStateText)
                            )
                          ])
                        ]
                      )
                    ])
                  ],
                  2
                )
              ]
            )
          ],
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass: "simple-tbl",
          staticStyle: {
            width: "100%",
            "table-layout": "fixed",
            "border-collapse": "collapse",
            "border-spacing": "2px",
            "border-color": "gray",
            color: "#666",
            "font-size": "12px"
          }
        },
        [
          _vm._m(18),
          _vm._v(" "),
          _c(
            "tbody",
            { staticClass: "body" },
            _vm._l(_vm.devcMaintVoucher.checkItemList, function(
              checkItem,
              index
            ) {
              return _c(
                "tr",
                { staticClass: "row" },
                [
                  checkItem.imgList != null && checkItem.imgList.length > 0
                    ? [
                        _c(
                          "td",
                          {
                            staticStyle: {
                              border: "1px solid #1a1a1a",
                              "vertical-align": "middle",
                              padding: "10px 4px"
                            }
                          },
                          [_c("div", [_vm._v(_vm._s(index + 1))])]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              border: "1px solid #1a1a1a",
                              "vertical-align": "middle",
                              padding: "10px 4px"
                            }
                          },
                          _vm._l(checkItem.imgList, function(imgFile) {
                            return _c("img", {
                              staticStyle: { width: "120px", height: "120px" },
                              attrs: { src: imgFile.fileBrowseUrl }
                            })
                          })
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            })
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass: "simple-tbl",
          staticStyle: {
            width: "100%",
            "table-layout": "fixed",
            "border-collapse": "collapse",
            "border-spacing": "2px",
            "border-color": "gray",
            color: "#666",
            "font-size": "12px"
          }
        },
        [
          _c("tbody", { staticClass: "body" }, [
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "border-bottom": "0px",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c("div", { staticClass: "info-item clearfix" }, [
                    _c(
                      "div",
                      {
                        staticClass: "label",
                        staticStyle: {
                          width: "160px",
                          float: "left",
                          color: "#1a1a1a",
                          "font-weight": "600",
                          "white-space": "normal",
                          "word-break": "break-all"
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.devcMaintVoucher.svcCmntLabel))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "value",
                        staticStyle: {
                          float: "left",
                          width: "-webkit-calc(100% - 160px)",
                          "white-space": "normal",
                          "word-break": "break-all"
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.devcMaintVoucher.svcCmntValue))
                        ])
                      ]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "border-bottom": "0px",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c("div", { staticClass: "info-item clearfix" }, [
                    _c(
                      "div",
                      {
                        staticClass: "label",
                        staticStyle: {
                          width: "160px",
                          float: "left",
                          color: "#1a1a1a",
                          "font-weight": "600",
                          "white-space": "normal",
                          "word-break": "break-all"
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.devcMaintVoucher.useCmntLabel))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "value",
                        staticStyle: {
                          float: "left",
                          width: "-webkit-calc(100% - 160px)",
                          "white-space": "normal",
                          "word-break": "break-all"
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.devcMaintVoucher.useCmntValue))
                        ])
                      ]
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "border-top": "0px",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "sign-name",
                      staticStyle: { height: "160px", "text-align": "center" }
                    },
                    [
                      _vm.devcMaintVoucher.sigRequired
                        ? _c("img", {
                            staticStyle: { height: "100px" },
                            attrs: { src: _vm.devcMaintVoucher.svcSigImgUrl }
                          })
                        : _c("span", [
                            _vm._v(_vm._s(_vm.devcMaintVoucher.svcSigImgUuid))
                          ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item clearfix" }, [
                    _c(
                      "div",
                      {
                        staticClass: "label",
                        staticStyle: {
                          width: "76px",
                          float: "left",
                          color: "#1a1a1a",
                          "font-weight": "600",
                          "white-space": "normal",
                          "word-break": "break-all"
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.devcMaintVoucher.svcDateLabel))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm.devcMaintVoucher.svcDateValue != null
                      ? _c(
                          "div",
                          {
                            staticClass: "value align-right",
                            staticStyle: {
                              float: "left",
                              width: "-webkit-calc(100% - 86px)",
                              "white-space": "normal",
                              "word-break": "break-all"
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  new Date(
                                    _vm.devcMaintVoucher.svcDateValue
                                  ).format("yyyy年MM月dd日")
                                )
                              )
                            ])
                          ]
                        )
                      : _vm._e()
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "border-top": "0px",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "sign-name",
                      staticStyle: { height: "160px", "text-align": "center" }
                    },
                    [
                      _vm.devcMaintVoucher.sigRequired
                        ? _c("img", {
                            staticStyle: { height: "100px" },
                            attrs: { src: _vm.devcMaintVoucher.useSigImgUrl }
                          })
                        : _c("span", [
                            _vm._v(_vm._s(_vm.devcMaintVoucher.useSigImgUuid))
                          ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item clearfix" }, [
                    _c(
                      "div",
                      {
                        staticClass: "label",
                        staticStyle: {
                          width: "76px",
                          float: "left",
                          color: "#1a1a1a",
                          "font-weight": "600",
                          "white-space": "normal",
                          "word-break": "break-all"
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.devcMaintVoucher.useDateLabel))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm.devcMaintVoucher.useDateValue != null
                      ? _c(
                          "div",
                          {
                            staticClass: "value align-right",
                            staticStyle: {
                              float: "left",
                              width: "-webkit-calc(100% - 86px)",
                              "white-space": "normal",
                              "word-break": "break-all"
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  new Date(
                                    _vm.devcMaintVoucher.useDateValue
                                  ).format("yyyy年MM月dd日")
                                )
                              )
                            ])
                          ]
                        )
                      : _vm._e()
                  ])
                ]
              )
            ])
          ])
        ]
      )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "th",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          color: "#1a1a1a",
          "font-weight": "60",
          width: "60px"
        }
      },
      [_c("div", [_vm._v("序号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "th",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          color: "#1a1a1a",
          "font-weight": "120",
          width: "60px"
        }
      },
      [_c("div", [_vm._v("分组")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "th",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          color: "#1a1a1a",
          "font-weight": "600"
        }
      },
      [_c("div", [_vm._v("维护保养项目（内容）")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "th",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          color: "#1a1a1a",
          "font-weight": "600"
        }
      },
      [_c("div", [_vm._v("维护保养基本要求")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "th",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          color: "#1a1a1a",
          "font-weight": "60",
          width: "60px"
        }
      },
      [_c("div", [_vm._v("需拍照")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "th",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          color: "#1a1a1a",
          "font-weight": "600"
        }
      },
      [_c("div", [_vm._v("结果")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "th",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          color: "#1a1a1a",
          "font-weight": "600"
        }
      },
      [_c("div", [_vm._v("结果说明")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "th",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          color: "#1a1a1a",
          "font-weight": "60",
          width: "60px"
        }
      },
      [_c("div", [_vm._v("序号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "th",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          color: "#1a1a1a",
          "font-weight": "600"
        }
      },
      [_c("div", [_vm._v("维护保养项目（内容）")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "th",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          color: "#1a1a1a",
          "font-weight": "600"
        }
      },
      [_c("div", [_vm._v("维护保养基本要求")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "th",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          color: "#1a1a1a",
          "font-weight": "60",
          width: "60px"
        }
      },
      [_c("div", [_vm._v("需拍照")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "th",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          color: "#1a1a1a",
          "font-weight": "600"
        }
      },
      [_c("div", [_vm._v("结果")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "th",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          color: "#1a1a1a",
          "font-weight": "600"
        }
      },
      [_c("div", [_vm._v("结果说明")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "th",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          color: "#1a1a1a",
          "font-weight": "60",
          width: "60px"
        }
      },
      [_c("div", [_vm._v("序号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "th",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          color: "#1a1a1a",
          "font-weight": "600"
        }
      },
      [_c("div", [_vm._v("维护保养项目（内容）")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "th",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          color: "#1a1a1a",
          "font-weight": "600"
        }
      },
      [_c("div", [_vm._v("维护保养基本要求")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "th",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          color: "#1a1a1a",
          "font-weight": "120"
        }
      },
      [_c("div", [_vm._v("维护保养情况")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "th",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          color: "#1a1a1a",
          "font-weight": "60",
          width: "60px"
        }
      },
      [_c("div", [_vm._v("需拍照")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "head" }, [
      _c("tr", { staticClass: "row" }, [
        _c(
          "th",
          {
            staticStyle: {
              border: "1px solid #1a1a1a",
              "vertical-align": "middle",
              padding: "10px 4px",
              color: "#1a1a1a",
              "font-weight": "60",
              width: "60px"
            }
          },
          [_c("div", [_vm._v("序号")])]
        ),
        _vm._v(" "),
        _c(
          "th",
          {
            staticStyle: {
              border: "1px solid #1a1a1a",
              "vertical-align": "middle",
              padding: "10px 4px",
              color: "#1a1a1a",
              "font-weight": "600"
            }
          },
          [_c("div", [_vm._v("图片")])]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-309c7980", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-309c7980","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/workVoucher/DevcMaintVoucherPdf.vue
// module id = 2775
// module chunks = 0